export const SET_DASHBOARD_LOADING = 'SET_DASHBOARD_LOADING'
export const GET_DATA = 'GET_DATA'
export const GET_CONTACTS_DATA = 'GET_CONTACTS_DATA'
export const CLEAR_CONTACTS_DATA = 'CLEAR_CONTACTS_DATA'
